import Alpine from 'alpinejs'

export const initBrandFilter = (): void => {
    Alpine.data('brandFilter', () => ({
        firstLoop: true,
        showSubfilters: true,
        models: [] as string[],
        brands: [] as string[],
        brandModels: {} as Record<string, Array<{ label: string }>>,
        modelToBrand: {} as Record<string, string>,
        init() {
            this.ReadFilterFromURL()
            if (!this.firstLoop) {
                this.$watch('models', () => this.updateModelFilter())
                this.$watch('brands', (value, oldValue) => this.updateBrandFilter(value, oldValue))
            }
            // this.showSubfilters = this.brands.length > 0
        },
        shouldBeCollapsed() {
            return this.models.length > 0 || this.brands.length > 0
        },
        updateModelFilter() {
            // Find which brands should be selected based on selected models
            // Use modelToBrand mapping to ensure we only match the exact brand for each model
            const brandsForSelectedModels = new Set<string>()

            // Find unique brands for all selected models
            this.models.forEach((model) => {
                const brand = this.modelToBrand[model]
                if (brand && !this.brands.includes(brand)) {
                    brandsForSelectedModels.add(brand)
                }
            })

            // Add parent brands if any models are selected
            if (brandsForSelectedModels.size > 0) {
                this.brands = [...this.brands, ...Array.from(brandsForSelectedModels)]
            }

            const event = new CustomEvent('update-filter', {
                detail: {
                    attribute: 'models',
                    value: this.models,
                    query: 'model[]',
                },
            })

            window.dispatchEvent(event)
        },
        updateBrandFilter(value: string[], oldValue: string[]) {
            const difference = oldValue.filter((x) => !value.includes(x))
            const removeModels: string[] = []
            let uncheckedBrand = ''

            if (difference.length) {
                uncheckedBrand = difference[0]

                for (const [brand, carModels] of Object.entries(this.brandModels)) {
                    if (brand === uncheckedBrand) {
                        if (Object.keys(carModels).length <= 0) continue
                        ;(carModels as Array<{ label: string }>).forEach((carModel) => {
                            if (this.models.includes(carModel.label)) {
                                removeModels.push(carModel.label)
                            }
                        })
                    }
                }
            }

            // Remove models from the models array when brand is deselected
            if (removeModels.length > 0) {
                this.models = this.models.filter((model) => !removeModels.includes(model))
            }

            const eventDetail: {
                attribute: string
                value: string[]
                query: string
                subQuery?: string
                subValues?: string[]
            } = {
                attribute: 'brands',
                value: this.brands,
                query: 'merk[]',
            }

            // Only include subValues when a brand is unchecked and there are models to remove
            if (removeModels.length > 0) {
                eventDetail.subQuery = 'model[]'
                eventDetail.subValues = removeModels
            }

            const event = new CustomEvent('update-filter', {
                detail: eventDetail,
            })

            window.dispatchEvent(event)
        },
        updateFilter() {
            const qp = new URLSearchParams()
            this.models.forEach((model) => qp.append('model[]', model))
            this.brands.forEach((brand) => qp.append('merk[]', brand))
        },
        setBrandModels(brand: string, models: Array<{ label: string }>) {
            this.brandModels[brand] = models
            // Create reverse mapping: model -> brand
            models.forEach((model) => {
                this.modelToBrand[model.label] = brand
            })
        },
        ReadFilterFromURL() {
            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.get('model[]')) {
                this.models = urlParams.getAll('model[]')
            }
            if (urlParams.get('merk[]')) {
                this.brands = urlParams.getAll('merk[]')
            }

            this.firstLoop = false
        },
    }))
}
